"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditAuditBatch = void 0;
const mobx_1 = require("mobx");
class EditAuditBatch {
    constructor(json) {
        this.locallySaveEnteredQuantity = (enteredQuantity) => {
            this.locallySavedEnteredQuantity = enteredQuantity;
        };
        this.id = json.id;
        this.inventoryAuditProductId = json.inventoryAuditProductId;
        this.batchId = json.batchId;
        this.batchNumber = json.batchNumber;
        this.expectedQuantity = json.expectedQuantity;
        this.enteredQuantity = json.enteredQuantity;
        this.locallySavedEnteredQuantity = json.enteredQuantity;
    }
    setEnteredQuantity(quantity) {
        this.enteredQuantity = quantity;
    }
}
__decorate([
    mobx_1.observable
], EditAuditBatch.prototype, "enteredQuantity", void 0);
__decorate([
    mobx_1.observable
], EditAuditBatch.prototype, "locallySavedEnteredQuantity", void 0);
__decorate([
    mobx_1.action
], EditAuditBatch.prototype, "setEnteredQuantity", null);
__decorate([
    mobx_1.action
], EditAuditBatch.prototype, "locallySaveEnteredQuantity", void 0);
exports.EditAuditBatch = EditAuditBatch;
//# sourceMappingURL=audit-lot.js.map